import project1 from "../assets/images/careers.png";
import project2 from "../assets/images/angular-shop.png";
import project3 from "../assets/images/responsive.png";
import project4 from "../assets/images/landing-page.png";
import project5 from "../assets/images/project5.png";
import project6 from "../assets/images/prime-health.png";
import standup1 from "../assets/images/standup1.png";
import project7 from "../assets/images/CodeCrew.png";

export const initialProjects = [
  {
    id: 1,
    img: null,
    name: "ZILP — Zimbabwe Indigenous Language Platform",
    description: "A production-grade AI infrastructure platform for indigenous language technologies. Supports corpus management, annotation workflows, multilingual datasets, speech resources, lexicography, terminology management, AI model development, and collaborative research across Zimbabwe's languages.",
    github_link: "https://github.com/wealthymanyasa",
    live_link: null,
    tech: ["Python", "Django", "DRF", "PostgreSQL", "Docker", "Redis", "Celery", "Next.js", "React", "TypeScript", "Tailwind", "FastAPI", "Transformers", "Whisper", "PyTorch"],
    featured: true,
    category: "ai"
  },
  {
    id: 2,
    img: null,
    name: "National Dataset Studio",
    description: "An enterprise platform for building AI-ready datasets. Features dataset versioning, annotation workflows, validation pipelines, audio collection, metadata management, team collaboration, workflow automation, and multi-format data exports for machine learning.",
    github_link: "https://github.com/wealthymanyasa",
    live_link: null,
    tech: ["Python", "Django", "PostgreSQL", "Docker", "React", "TypeScript", "Redis", "Celery"],
    featured: true,
    category: "ai"
  },
  {
    id: 3,
    img: null,
    name: "Speech AI Platform",
    description: "A comprehensive speech technology platform enabling speech collection, automatic transcription with Whisper, forced alignment, speaker identification, audio annotation, speech dataset management, and AI model evaluation for low-resource languages.",
    github_link: "https://github.com/wealthymanyasa",
    live_link: null,
    tech: ["Python", "FastAPI", "Whisper", "PyTorch", "PostgreSQL", "Docker", "React", "TypeScript"],
    featured: true,
    category: "ai"
  },
  {
    id: 4,
    img: null,
    name: "Multilingual Glossary Platform",
    description: "A terminology and dictionary management platform supporting multilingual glossary creation, translation workflows, community contributions, version control, and web publishing for language resource development.",
    github_link: "https://github.com/wealthymanyasa",
    live_link: null,
    tech: ["Python", "Django", "PostgreSQL", "React", "TypeScript", "Docker"],
    featured: true,
    category: "ai"
  },
  {
    id: 5,
    img: standup1,
    name: "Next.js Video Conferencing WebApp",
    github_link: "https://github.com/wealthymanyasa/standup-video-conferencing.git",
    live_link: "https://standup-video-conferencing-nextjs.vercel.app/",
    tech: ["Next.js", "WebRTC", "Tailwind"],
    featured: false,
    category: "web"
  },
  {
    id: 6,
    img: project1,
    name: "Nike Store",
    github_link: "https://github.com/wealthymanyasa/nike-landing-react-tailwind",
    live_link: "https://nike-landing-page-react-tailwind.vercel.app/",
    tech: ["React", "Tailwind CSS", "JavaScript"],
    featured: false,
    category: "web"
  },
  {
    id: 7,
    img: project7,
    name: "CodeCrew React Engineering Website UI",
    github_link: "https://github.com/wealthymanyasa/codecrew",
    live_link: "https://codecrew-six.vercel.app/",
    tech: ["React", "Tailwind CSS", "JavaScript"],
    featured: false,
    category: "web"
  },
  {
    id: 8,
    img: project2,
    name: "Angular Shopping Cart",
    github_link: "https://github.com/wealthymanyasa/angular-cart",
    live_link: "https://angular-cart-82b4a.web.app/",
    tech: ["Angular", "Firebase", "TypeScript"],
    featured: false,
    category: "web"
  },
  {
    id: 9,
    img: project3,
    name: "Single Page Responsive",
    github_link: "https://github.com/wealthymanyasa/manyasaprofile",
    live_link: "https://manyasaprofile-c3597.web.app/",
    tech: ["HTML", "CSS", "JavaScript"],
    featured: false,
    category: "web"
  },
  {
    id: 10,
    img: project4,
    name: "Tailwind Landing Page",
    github_link: "https://github.com/wealthymanyasa/landingpage-tailwind",
    live_link: "https://wealthymanyasa.github.io/landingpage-tailwind/",
    tech: ["Tailwind", "HTML", "JavaScript"],
    featured: false,
    category: "web"
  },
  {
    id: 11,
    img: project5,
    name: "Cloud App React Tailwind",
    github_link: "https://github.com/wealthymanyasa/cloud-app-tailwind-react",
    live_link: "https://cloud-app-tailwind-react.vercel.app",
    tech: ["React", "Tailwind", "JavaScript"],
    featured: false,
    category: "web"
  },
  {
    id: 12,
    img: project6,
    name: "Prime-Health React Tailwind",
    github_link: "https://github.com/wealthymanyasa/prime-health-responsive-landing-page",
    live_link: "https://prime-health-tailwind.web.app/",
    tech: ["React", "Tailwind", "Firebase"],
    featured: false,
    category: "web"
  }
];

export const initialSkills = [
  // AI & Machine Learning
  { id: 1, name: "Python", category: "AI & Machine Learning", icon: "Py" },
  { id: 2, name: "PyTorch", category: "AI & Machine Learning", icon: "PT" },
  { id: 3, name: "TensorFlow", category: "AI & Machine Learning", icon: "TF" },
  { id: 4, name: "Scikit-learn", category: "AI & Machine Learning", icon: "SK" },
  { id: 5, name: "Transformers", category: "AI & Machine Learning", icon: "🤖" },
  { id: 6, name: "Sentence Transformers", category: "AI & Machine Learning", icon: "ST" },
  { id: 7, name: "spaCy", category: "AI & Machine Learning", icon: "sp" },
  { id: 8, name: "NLTK", category: "AI & Machine Learning", icon: "NL" },
  { id: 9, name: "Whisper", category: "AI & Machine Learning", icon: "🎤" },
  { id: 10, name: "OpenAI APIs", category: "AI & Machine Learning", icon: "OA" },
  { id: 11, name: "LLMs", category: "AI & Machine Learning", icon: "🧠" },
  { id: 12, name: "Prompt Engineering", category: "AI & Machine Learning", icon: "PE" },
  { id: 13, name: "RAG", category: "AI & Machine Learning", icon: "RA" },
  { id: 14, name: "Model Evaluation", category: "AI & Machine Learning", icon: "📊" },
  { id: 15, name: "Machine Translation", category: "AI & Machine Learning", icon: "🌐" },
  { id: 16, name: "Speech Recognition", category: "AI & Machine Learning", icon: "🗣" },
  { id: 17, name: "NER", category: "AI & Machine Learning", icon: "NE" },
  { id: 18, name: "POS Tagging", category: "AI & Machine Learning", icon: "PO" },
  { id: 19, name: "Morphological Analysis", category: "AI & Machine Learning", icon: "MA" },
  { id: 20, name: "Knowledge Graphs", category: "AI & Machine Learning", icon: "KG" },

  // Backend Engineering
  { id: 21, name: "Django", category: "Backend Engineering", icon: "Dj" },
  { id: 22, name: "Django REST Framework", category: "Backend Engineering", icon: "DR" },
  { id: 23, name: "FastAPI", category: "Backend Engineering", icon: "FA" },
  { id: 24, name: "Celery", category: "Backend Engineering", icon: "Ce" },
  { id: 25, name: "Redis", category: "Backend Engineering", icon: "Re" },
  { id: 26, name: "PostgreSQL", category: "Backend Engineering", icon: "PG" },
  { id: 27, name: "REST APIs", category: "Backend Engineering", icon: "🌐" },
  { id: 28, name: "GraphQL", category: "Backend Engineering", icon: "GQ" },
  { id: 29, name: "Authentication", category: "Backend Engineering", icon: "🔐" },
  { id: 50, name: "Background Processing", category: "Backend Engineering", icon: "⚙️" },
  { id: 51, name: "Caching", category: "Backend Engineering", icon: "💾" },
  { id: 52, name: "Microservices", category: "Backend Engineering", icon: "MS" },

  // Frontend Engineering
  { id: 30, name: "React", category: "Frontend Engineering", icon: "⚛️" },
  { id: 31, name: "Next.js", category: "Frontend Engineering", icon: "▲" },
  { id: 32, name: "TypeScript", category: "Frontend Engineering", icon: "TS" },
  { id: 33, name: "JavaScript", category: "Frontend Engineering", icon: "JS" },
  { id: 34, name: "Tailwind CSS", category: "Frontend Engineering", icon: "TW" },
  { id: 35, name: "shadcn/ui", category: "Frontend Engineering", icon: "SU" },
  { id: 36, name: "Framer Motion", category: "Frontend Engineering", icon: "FM" },
  { id: 53, name: "TanStack Query", category: "Frontend Engineering", icon: "TQ" },
  { id: 54, name: "TanStack Table", category: "Frontend Engineering", icon: "TT" },
  { id: 55, name: "Responsive Design", category: "Frontend Engineering", icon: "📱" },

  // DevOps & Infrastructure
  { id: 37, name: "Docker", category: "DevOps & Infrastructure", icon: "🐳" },
  { id: 38, name: "Docker Compose", category: "DevOps & Infrastructure", icon: "DC" },
  { id: 39, name: "Linux", category: "DevOps & Infrastructure", icon: "🐧" },
  { id: 40, name: "Nginx", category: "DevOps & Infrastructure", icon: "NG" },
  { id: 41, name: "GitHub Actions", category: "DevOps & Infrastructure", icon: "GA" },
  { id: 42, name: "CI/CD", category: "DevOps & Infrastructure", icon: "🔄" },
  { id: 56, name: "Monitoring", category: "DevOps & Infrastructure", icon: "📈" },
  { id: 57, name: "Production Deployments", category: "DevOps & Infrastructure", icon: "🚀" },
  { id: 58, name: "Cloud Infrastructure", category: "DevOps & Infrastructure", icon: "☁️" },
  { id: 59, name: "Database Backups", category: "DevOps & Infrastructure", icon: "🗄️" },

  // Databases
  { id: 43, name: "PostgreSQL", category: "Databases", icon: "🐘" },
  { id: 44, name: "Redis", category: "Databases", icon: "🔴" },
  { id: 45, name: "MongoDB", category: "Databases", icon: "🍃" },
  { id: 60, name: "SQLite", category: "Databases", icon: "SQ" },

  // Tools
  { id: 46, name: "Git", category: "Tools", icon: "Git" },
  { id: 47, name: "GitHub", category: "Tools", icon: "GH" },
  { id: 48, name: "VS Code", category: "Tools", icon: "VS" },
  { id: 49, name: "Jupyter", category: "Tools", icon: "📓" },
  { id: 61, name: "Postman", category: "Tools", icon: "PM" },
  { id: 62, name: "Figma", category: "Tools", icon: "Fi" },
];

export const initialHero = {
  name: "Obert Manyasa",
  title: "Building the Future of African Language AI",
  subtitle: "Machine Learning Engineer (NLP) • AI Engineer • Full-Stack Platform Architect",
  description: "I design and build production-grade AI infrastructure for indigenous languages, including dataset platforms, annotation systems, speech technologies, machine translation, AI model development, and language resource management across Zimbabwe and Africa.",
  ctaText: "Explore My Work",
  ctaLink: "#projects"
};

export const initialAbout = {
  title: "About Me",
  description: "I am a Machine Learning Engineer (NLP), AI Engineer, and Full-Stack Software Engineer specializing in Language Technology. My work focuses on Natural Language Processing, Language AI Infrastructure, Speech Technologies, Machine Translation, and Language Resource Development.\n\nI currently lead AI and NLP system creation for under-resourced Bantu languages at Midlands State University's National Language Institute, where I design end-to-end ML pipelines covering data curation, model training, evaluation, and production rollout.\n\nMy work includes developing robust translation engines, advanced spell-checkers, and retrieval-augmented generation (RAG) chatbots. I have deployed FastAPI inference services handling 50k+ requests per day and implement scalable MLOps workflows for automated model training and monitoring.\n\nMy mission is to contribute to the future of AI for low-resource African languages through modern engineering, research, and open-source infrastructure.",
  mission: "Building AI infrastructure that empowers African languages in the digital age."
};

export const initialResearch = [
  { area: "Low-Resource NLP", description: "Developing NLP techniques for Bantu languages with limited digital resources and training data" },
  { area: "African Language AI", description: "Building AI systems that understand and generate African languages including Shona and Ndebele" },
  { area: "Machine Translation", description: "Neural machine translation systems for under-represented Bantu language pairs" },
  { area: "Speech Recognition", description: "Automatic speech recognition for low-resource African languages" },
  { area: "Speech Synthesis", description: "Text-to-speech systems for languages with limited phonetic data" },
  { area: "Corpus Linguistics", description: "Designing and building representative linguistic corpora" },
  { area: "Lexicography", description: "Digital lexicography and computational dictionary development" },
  { area: "Language Documentation", description: "Technology-assisted language documentation and preservation" },
  { area: "OCR", description: "Optical character recognition for African language scripts and orthographies" },
  { area: "Large Language Models", description: "Adapting and fine-tuning LLMs for African language contexts" },
  { area: "Dataset Engineering", description: "Methodologies for creating high-quality AI training datasets" },
  { area: "AI Evaluation", description: "Evaluation frameworks for NLP systems on African languages" },
  { area: "Knowledge Graphs", description: "Building structured knowledge representations for language resources" },
  { area: "Retrieval-Augmented Generation", description: "RAG systems for multilingual and low-resource contexts" },
  { area: "AI Agents", description: "Language-capable AI agents for African language interfaces" },
];

export const initialServices = [
  { title: "AI Platform Engineering", description: "Design and build production-grade AI platforms for language technologies, from data ingestion to model deployment.", icon: "🧠" },
  { title: "NLP Systems Development", description: "Develop natural language processing systems including tokenization, tagging, parsing, and semantic analysis pipelines.", icon: "📝" },
  { title: "Language Technology Solutions", description: "End-to-end language technology solutions for corpus management, lexicography, and terminology platforms.", icon: "🌐" },
  { title: "Dataset Engineering", description: "Architect and build AI-ready datasets with versioning, annotation workflows, validation pipelines, and multi-format exports.", icon: "💾" },
  { title: "Speech AI Systems", description: "Speech collection, transcription (ASR), forced alignment, speaker identification, and TTS systems for low-resource languages.", icon: "🎤" },
  { title: "Backend Architecture", description: "Scalable backend systems using Django, FastAPI, PostgreSQL, Redis, Celery, and microservice patterns.", icon: "⚙️" },
  { title: "Research Software Engineering", description: "Bridge the gap between NLP research and production systems with reproducible, well-engineered codebases.", icon: "🔬" },
  { title: "AI Infrastructure Consulting", description: "Strategic consulting on AI infrastructure, MLOps, dataset pipelines, and language technology architecture.", icon: "📊" },
  { title: "Technical Architecture", description: "System design and technical architecture for AI platforms, ensuring scalability, reliability, and maintainability.", icon: "🏗️" },
];

export const initialImpact = [
  { title: "National Language Datasets", description: "Building comprehensive, standardized datasets for Zimbabwe's indigenous languages, enabling AI research and application development." },
  { title: "Speech Corpora", description: "Collecting and annotating speech data for African languages to enable voice interfaces, transcription, and speech-based applications." },
  { title: "Digital Language Preservation", description: "Using technology to document, preserve, and revitalize indigenous languages through digital resources and AI-powered tools." },
  { title: "AI-Ready Data", description: "Creating high-quality, well-structured datasets that meet the requirements of modern machine learning pipelines and research." },
  { title: "Machine Translation", description: "Developing translation systems for African language pairs, enabling cross-lingual communication and content accessibility." },
  { title: "Language Model Development", description: "Adapting and training language models for low-resource African languages, advancing NLP capabilities for under-served communities." },
  { title: "Annotation Platforms", description: "Building collaborative annotation infrastructure that enables linguists and researchers to create high-quality labeled data." },
  { title: "Open Research Infrastructure", description: "Creating open-source tools, datasets, and infrastructure to democratize AI research for African languages." },
];

export const initialProjectsConfig = {
  aiHeading: "AI & Language Infrastructure",
  aiDescription: "Production-grade platforms for African language AI, from dataset engineering to model deployment",
  webHeading: "Web Engineering Projects",
  webDescription: "Earlier projects showcasing full-stack engineering foundations",
};

export const initialTimeline = [
  { startDate: "Nov 2024", endDate: "Present", title: "Machine Learning Engineer (NLP)", subtitle: "Midlands State University · National Language Institute", description: "Leading AI and NLP system creation for under-resourced Bantu languages including Shona and Ndebele. Designing end-to-end ML pipelines covering data curation, model training, evaluation, and production rollout. Developing translation engines, spell-checkers, and RAG chatbots. Deployed FastAPI inference service handling 50k+ requests/day. Mentoring junior developers and guiding the institute's language technology roadmap.", icon: "🧠" },
  { startDate: "Jul 2024", endDate: "Nov 2024", title: "Software Developer", subtitle: "National Data Solutions · Remote (US)", description: "Full-stack software engineering using React.js and TypeScript for US-based data solutions company. Built and maintained production web applications with modern JavaScript frameworks.", icon: "💻" },
  { startDate: "Jun 2023", endDate: "Jul 2024", title: "Senior Software Engineer (DevOps)", subtitle: "Qubed Care LLC · Remote (Dallas, Texas)", description: "Senior engineering role focused on DevOps practices. Worked extensively with Docker, CI/CD pipelines, and cloud infrastructure to maintain and improve deployment workflows for healthcare technology systems.", icon: "⚙️" },
  { startDate: "Mar 2022", endDate: "Jun 2023", title: "Web Developer", subtitle: "Web Entangled · Harare, Zimbabwe", description: "Developed UI and backends. Built and modified data input systems, file/database structures, data transformation pipelines, and algorithms. Documented code and processes adhering to development methodologies.", icon: "🌐" },
  { startDate: "Jul 2021", endDate: "Mar 2022", title: "IT Developer and Administrator", subtitle: "Dun & Bradstreet · Harare, Zimbabwe", description: "Worked with Laravel, JavaScript, Node.js, and C# (MVVM). Developed technical documentation, diagnosed network problems, collected IT usage statistics, and managed IT infrastructure to maintain system uptime.", icon: "🔧" },
  { startDate: "2018", endDate: "2021", title: "Honours Degree in Information Systems", subtitle: "Great Zimbabwe University · 3.7 GPA", description: "Honours Degree in Information Systems with a strong focus on computer programming. Active researcher in the Computing Research Forum.", icon: "🎓" },
];
